export const URL_DOWNLOAD = "/services/plugin-upload/download"
export const URL_DOWNLOAD_PUBLIC = "/open/plugin-upload/download"
